import {TrackingEvent as TableTrackingEvent} from 'common/components/table/tracking';
import {SearchTrackedEvent} from 'common/report/util/search/tracking';

export const CAPTURED_TRACKING = new Set<string>([
  `[mp-table] ${TableTrackingEvent.SortChange}`,
  ...Object.values(SearchTrackedEvent),
]);
